import {listener} from "../../../../../modules/vegas/js/util";
import VGCatalogCart from "./cart";
import {timeout} from "../../../vg/modules/timeout";

// меняем количество из списка товаров
listener('change-counter', '[data-product-item] [data-cart="qty"]', function (el, e) {
	let product = el.closest('[data-product-item]');

	timeout('change-product-cart-qty', 200, () => {
		new VGCatalogCart().change(product, e.detail.cnt);
	});
}, true);

// меняем количество с корзины
listener('change-counter', '[data-product-cart-item] [data-cart="qty"]', function (el, e) {
	let product = el.closest('[data-product-cart-item]');

	timeout('change-product-cart-qty', 250, () => {
		new VGCatalogCart().change(product, e.detail.cnt, {
			pivot_id: product.dataset.pivot_id,
			get_products_totals: true,
		});
	});

	timeout('change-product-cart-qty-totals', 1000, () => {
		new VGCatalogCart().update({
			get_delivery_prices: true,
			get_payments_info: true
		});
	});
}, true);

// меняем количество из карточки товара
listener('change-counter', '[data-product].in-cart [data-cart="qty"]', function (el, e) {
	let product = el.closest('[data-product]');

	timeout('change-product-card-cart-qty', 200, () => {
		new VGCatalogCart().change(product, e.detail.cnt);
	});
}, true);
